export default "__VITE_ASSET__Wp$9FpAR__"